import React, { useEffect } from 'react';
import './App.css';

const PrivacyPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <section className="privacy-page-content content-container">
      <h1 className="ultra-title" style={{ fontSize: '3rem', marginTop: '150px', textAlign: 'center' }}>PRIVACY POLICY</h1>
      <div className="accent-bar"></div>
      
      <div className="article-content" style={{ color: '#ccc', lineHeight: '1.8' }}>
        <p style={{ textAlign: 'center', color: '#b11226' }}>LAST UPDATED: DECEMBER 2025</p>
        
        <h3>1. DATA PROTECTION OVERVIEW</h3>
        <p>At Mafia Pass-n-Play, we prioritize user anonymity. We do not require account creation, nor do we collect personal identifiers such as phone numbers or physical addresses. Our application is a pass-and-play experience where game data is stored locally and temporarily.</p>

        <h3>2. GOOGLE ADSENSE AND COOKIES</h3>
        <p>This website uses Google AdSense to serve advertisements. Google uses cookies to serve ads based on your prior visits to this website or other websites. Google's use of advertising cookies enables it and its partners to serve ads to you based on your visit to our site and/or other sites on the Internet.</p>
        <p>You may opt out of personalized advertising by visiting Google Ad Settings. Alternatively, you can opt out of a third-party vendor's use of cookies for personalized advertising by visiting aboutads.info.</p>

        <h3>3. LOG FILES AND ANALYTICS</h3>
        <p>Like many other websites, we make use of log files. These files merely log visitors to the site—usually a standard procedure for hosting companies and a part of hosting services' analytics. The information inside the log files includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date/time stamp, referring/exit pages, and possibly the number of clicks.</p>

        <h3>4. THIRD PARTY PRIVACY POLICIES</h3>
        <p>You should consult the respective privacy policies of these third-party ad servers for more detailed information on their practices as well as for instructions about how to opt-out of certain practices. Our privacy policy does not apply to, and we cannot control the activities of, such other advertisers or web sites.</p>

        <h3>5. CONSENT</h3>
        <p>By using our website, you hereby consent to our privacy policy and agree to its terms. If you require any more information or have any questions about our privacy policy, please feel free to contact us by email at mafiapassnplay@gmail.com.</p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;